import Button from "@material-ui/core/Button";
import theme from "../constants/theme";
import { styled } from "@material-ui/core/styles";

export default styled(Button)({
  borderRadius: 4,
  height: theme.spacing(6),
  padding: theme.spacing(0, 4),
  margin: theme.spacing(2, 0, 2),
  textTransform: "none",
  fontWeight: "bold",
  background: theme.palette.primary.main,
  color: "#fff",
  [theme.breakpoints.only("xs")]: {
    width: "100%",
  },
  "&:hover": {
    background: theme.palette.secondary.main,
  },
});
